<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogIsOpen" scrollable persistent lazy max-width="550px">
      <v-card>
        <v-card-title >
          <div class="headline">Select an Account</div>
        </v-card-title>
        <v-card-text>     
          <p>We found multiple accounts associated with your login. Please choose 
          the account you'd like to access.</p>

          <v-radio-group v-model="selectedAccountId" class="accounts-list">
            <v-radio
              v-for="account in accounts"
              :key="account.accountId"
              :value="account.accountId"
              class="account-list--item"
            >
              <template slot="label">
                <strong>{{ account.accountId }}</strong>
                <div v-if="account.services.length > 0">
                  <h3 class="subheader">Associated Numbers</h3>
                  <ul class="services-list">
                    <li 
                      v-for="service in account.services"
                      :key="service.serviceId"
                    >
                      {{ service.telephoneNumber | service.provisioning.telephoneNumber | phone }}
                    </li>
                  </ul>                  
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="chooseAccount" :disabled="!selectedAccountId">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    props: {
      dialogIsOpen: {
        type: Boolean,
        default: false
      },
      accounts: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        selectedAccountId: null
      }
    },
    methods: {
      close () {
        this.$emit('toggleDialog', !this.dialogIsOpen)
      },
      chooseAccount () {
        var selectedAccount = this.accounts.find((account) => {
          return account.accountId === this.selectedAccountId
        })
        this.$emit('selectedAccount', selectedAccount)
      }
    }
  }
</script>

<style scoped lang="scss">
// Multi-line radio buttons
.accounts-list .input-group.input-group--selection-controls /deep/ label {
  height: auto;
  position: relative;
}

.accounts-list .input-group.input-group--selection-controls /deep/ .input-group__input {
  position: absolute;
}

.account-list--item {
  border-bottom: 1px solid #eee;
  padding: 8px 5px;

  &:last-child {
    border: 0;
  }

  .subheader {
    height: auto;
  }
}

.services-list {
  font-size: 12px;
  margin-left: 20px;
  list-style: none;
}
</style>


// WEBPACK FOOTER //
// src/components/user/AccountPicker.vue